// Home.js
import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Home2 from "./Home2";
import Type from "./Type";
import altImage from "../../Assets/alt_logo.png";

function Home() {
  return (
    <section>
      <Container fluid className="home-section" id="home">
        <Container className="home-content">
          <Row className="align-items-center gy-5">
            <Col md={7} className="home-header">

              <h1 className="heading">
                Helping Black Churches Turn Compassion Into Lasting Community Impact 
              </h1>

              <p className="heading-name">
                Shared Success Foundation provides funding to Churches to carry out their
                ministry of service and show Christ’s compassion in their Community
              </p>

              <p className="hero-copy">
                Our mission centers on programs that show the love of Christ in strengthening
                community, building economic self-sufficiency and building a spirit of unity
              </p>

              <div className="type-shell">
                <Type />
              </div>

              <div className="hero-stat-grid">
                <div className="hero-stat-card">
                  <strong>4</strong>
                  <span>Core funding priorities shaping our grant support</span>
                </div>
                <div className="hero-stat-card">
                  <strong>Church-led</strong>
                  <span>Programs rooted in trusted community relationships</span>
                </div>
                <div className="hero-stat-card">
                  <strong>Matthew 25:35-40</strong>
                  <span>Compassion-driven action with measurable local outcomes</span>
                </div>
              </div>
            </Col>

            <Col md={5} className="hero-visual-wrap">
              <div className="hero-visual-card">
                <img src={altImage} alt="Shared Success Foundation mark" className="img-fluid" />
              </div>
            </Col>
          </Row>
        </Container>
      </Container>
      <Home2 />
    </section>
  );
}

export default Home;
